import * as React from "react";
import { ListGroup, ListGroupItem } from "components/bootstrap";
const EventTypeFilter = ({ onSelect, selectedValues }) => {
  const disabledAlertOption = selectedValues.includes("true");
  const disabledEventOption = selectedValues.includes("false");
  return /* @__PURE__ */ React.createElement(ListGroup, { className: "no-bm" }, /* @__PURE__ */ React.createElement(ListGroupItem, { onClick: () => !disabledAlertOption && onSelect("true"), disabled: disabledAlertOption }, "Alert"), /* @__PURE__ */ React.createElement(ListGroupItem, { onClick: () => !disabledEventOption && onSelect("false"), disabled: disabledEventOption }, "Event"));
};
export default EventTypeFilter;
